/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './silos-admin.scss';

/* eslint-disable import/no-unresolved, import/default */

import silosAdminTemplate from './silos-admin.tpl.html';
import addSiloTemplate from './add-silo.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.silosAdmin', [])
    .directive('agSilosAdmin', SilosAdmin)
    .name;

/*@ngInject*/
function SilosAdmin() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: SilosAdminController,
        controllerAs: 'vm',
        templateUrl: silosAdminTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function SilosAdminController($rootScope, $scope, $document, $mdDialog, $q, $filter, $mdMedia,
                                   $translate, agTypes, types, userService, siloService, siloGroupService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN';
    vm.hasData = false;

    vm.silos = [];
    vm.silosCount = 0;
    vm.allSilos = [];
    vm.selectedSilos = [];

    vm.displayPagination = true;

    vm.currentSilo = null;

    vm.query = {
        order: 'name',
        limit: 5,
        page: 1,
        search: null
    };

    vm.addSiloAction = {
        name: 'ag.silo.add',
        show: true,
        onAction: function($event) {
            vm.addSilo($event);
        },
        icon: 'add'
    };

    vm.searchAction = {
        name: 'action.search',
        show: true,
        onAction: function() {
            vm.enterFilterMode();
        },
        icon: 'search'
    };

    vm.refreshAction = {
        name: 'action.refresh',
        show: true,
        onAction: function() {
            vm.reloadSilos();
        },
        icon: 'refresh'
    };

    vm.onRowClick = onRowClick;
    vm.isCurrent = isCurrent;
    vm.enterFilterMode = enterFilterMode;
    vm.exitFilterMode = exitFilterMode;
    vm.onReorder = onReorder;
    vm.onPaginate = onPaginate;
    vm.addSilo = addSilo;
    vm.copySilo = copySilo;
    vm.moveSilo = moveSilo;
    vm.gotoSiloDetails = gotoSiloDetails;
    vm.deleteSilo = deleteSilo;
    vm.deleteSilos = deleteSilos;
    vm.reloadSilos = reloadSilos;
    vm.updateSilos = updateSilos;

    $scope.$watch(function() { return $mdMedia('gt-xs'); }, function(isGtXs) {
        vm.isGtXs = isGtXs;
    });

    $scope.$watch(function() { return $mdMedia('gt-md'); }, function(isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [5, 10, 15];
        } else {
            vm.limitOptions = null;
        }
    });

    $scope.$watch('vm.ctx', function() {
        if (vm.showData && vm.ctx) {
            vm.isEdit = vm.ctx.isEdit;
            vm.siloGroupId = null;
            if (vm.ctx.stateController) {
                vm.siloGroupId = vm.ctx.stateController.getStateParams().entityId;
            }
            vm.ctx.widgetActions = [ vm.addSiloAction, vm.searchAction, vm.refreshAction ];
            vm.ctx.widgetTitle = $translate.instant('ag.silo.silos') + '';
            vm.displayPagination = angular.isDefined(vm.ctx.settings.displayPagination) ? vm.ctx.settings.displayPagination : true;
            reloadSilos();
        }
    });

    $scope.$on('editModeChanged', function() {
        vm.isEdit = vm.ctx.isEdit;
    });

    $scope.$watch("vm.query.search", function(newVal, prevVal) {
        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
            updateSilos();
        }
    });

    $scope.$watch("vm.currentSilo", function(newVal, prevVal) {
        if (!angular.equals(newVal, prevVal)) {
            var siloId = vm.currentSilo ? vm.currentSilo.id : null;
            $rootScope.$broadcast('siloSelected', siloId);
            $rootScope.$broadcast('siteAssetSelected', siloId, agTypes.assetType.silo);
        }
    });

    $scope.$on('siteAssetSelected', function(event, siteAssetId) {
        if (siteAssetId) {
            var result = $filter('filter')(vm.allSilos, {id: { id: siteAssetId.id } }, true);
            if (result && result.length) {
                var newCurrentSilo = result[0];
                vm.currentSilo = newCurrentSilo;
            }
        }
    });

    $scope.$on('siloUpdated', function(event, silo) {
        var result = $filter('filter')(vm.allSilos, {id: { id: silo.id.id } }, true);
        if (result && result.length) {
            var prevSilo = result[0];
            var index = vm.allSilos.indexOf(prevSilo);
            vm.allSilos[index] = silo;
            index = vm.silos.indexOf(prevSilo);
            if (index > -1) {
                vm.silos[index] = silo;
            }
        }
    });

    $scope.$watch('vm.selectedSilos.length', function (newLength) {
        var selectionMode = newLength ? true : false;
        if (vm.ctx) {
            if (selectionMode) {
                vm.ctx.hideTitlePanel = true;
            } else if (vm.query.search == null) {
                vm.ctx.hideTitlePanel = false;
            }
        }
    });

    $scope.$on('siloCopied', function() {
        reloadSilos(true);
    });

    $scope.$on('siloMoved', function() {
        reloadSilos();
    });

    function onRowClick($event, silo) {
        if (vm.currentSilo != silo) {
            vm.currentSilo = silo;
        }
        vm.ctx.stateController.openRightLayout();
    }

    function isCurrent(silo) {
        return (vm.currentSilo && silo) &&
            (vm.currentSilo.id.id === silo.id.id);
    }

    function enterFilterMode () {
        vm.query.search = '';
        vm.ctx.hideTitlePanel = true;
    }

    function exitFilterMode () {
        vm.query.search = null;
        updateSilos();
        vm.ctx.hideTitlePanel = false;
    }

    function onReorder () {
        updateSilos();
    }

    function onPaginate () {
        updateSilos();
    }

    function addSilo($event) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: AddSiloController,
            controllerAs: 'vm',
            templateUrl: addSiloTemplate,
            parent: angular.element($document[0].body),
            locals: {
                siloGroupId: vm.siloGroupId
            },
            fullscreen: true,
            targetEvent: $event
        }).then(function () {
            reloadSilos();
        }, function () {
        });
    }

    function copySilo($event, silo) {
        siloService.copySiloDialog($event, silo).then(
            function() {
                reloadSilos();
            }
        );
    }

    function moveSilo($event, silo) {
        siloService.moveSiloDialog($event, silo, vm.siloGroupId).then(
            function() {
                reloadSilos();
            }
        );
    }

    function gotoSiloDetails($event, silo) {
        if ($event) {
            $event.stopPropagation();
        }
        var params = {
            entityId: silo.id
        };
        vm.ctx.stateController.openState(agTypes.adminState.silo, params);
    }

    function deleteSilo($event, silo) {
        if ($event) {
            $event.stopPropagation();
        }
        if (silo) {
            var name = silo.name;
            var title = $translate.instant('ag.silo.delete-silo-title', {siloName: name});
            var content = $translate.instant('ag.silo.delete-silo-text');
            var confirm = $mdDialog.confirm()
                .targetEvent($event)
                .title(title)
                .htmlContent(content)
                .ariaLabel(title)
                .cancel($translate.instant('action.no'))
                .ok($translate.instant('action.yes'));
            $mdDialog.show(confirm).then(function () {
                siloService.deleteSilo(silo.id).then(
                    function success() {
                        reloadSilos();
                    }
                );
            });
        }
    }

    function deleteSilos($event) {
        if ($event) {
            $event.stopPropagation();
        }
        if (vm.selectedSilos && vm.selectedSilos.length > 0) {
            var title = $translate.instant('ag.silo.delete-silos-title', {count: vm.selectedSilos.length}, 'messageformat');
            var content = $translate.instant('ag.silo.delete-silos-text');
            var confirm = $mdDialog.confirm()
                .targetEvent($event)
                .title(title)
                .htmlContent(content)
                .ariaLabel(title)
                .cancel($translate.instant('action.no'))
                .ok($translate.instant('action.yes'));
            $mdDialog.show(confirm).then(function () {
                var tasks = [];
                for (var i=0;i<vm.selectedSilos.length;i++) {
                    var silo = vm.selectedSilos[i];
                    tasks.push(siloService.deleteSilo(silo.id));
                }
                $q.all(tasks).then(function () {
                    reloadSilos();
                });

            });
        }
    }

    function reloadSilos (keepSelection) {
        vm.allSilos.length = 0;
        vm.silos.length = 0;
        if (!keepSelection) {
            vm.currentSilo = null;
        }
        if (vm.siloGroupId) {
            vm.silosPromise = siloGroupService.getSiloGroupSilos(vm.siloGroupId);
            vm.silosPromise.then(
                function success(allSilos) {
                    vm.allSilos = allSilos;
                    vm.selectedSilos = [];
                    vm.updateSilos();
                    vm.silosPromise = null;
                },
                function fail() {
                    vm.allSilos = [];
                    vm.selectedSilos = [];
                    vm.updateSilos();
                    vm.silosPromise = null;
                }
            )
        } else {
            vm.updateSilos();
        }
    }

    function updateSilos () {
        vm.selectedSilos = [];
        var result = $filter('orderBy')(vm.allSilos, vm.query.order);
        if (vm.query.search != null) {
            result = $filter('filter')(result, {$: vm.query.search});
        }
        vm.silosCount = result.length;

        if (vm.displayPagination) {
            var startIndex = vm.query.limit * (vm.query.page - 1);
            vm.silos = result.slice(startIndex, startIndex + vm.query.limit);
        } else {
            vm.silos = result;
        }
    }

}

/*@ngInject*/
function AddSiloController($scope, $mdDialog, types, agTypes, siloService, siloGroupId) {

    var vm = this;

    vm.siloGroupId = siloGroupId;

    vm.silo = {
        id: {
            entityType: types.entityType.asset
        },
        type: agTypes.assetType.silo,
        maxTelemetryDelaySec: agTypes.defaults.silo.maxTelemetryDelaySec
    };

    vm.add = add;
    vm.cancel = cancel;

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        siloService.saveSilo(vm.silo, vm.siloGroupId).then(function success(silo) {
            vm.silo = silo;
            $scope.theForm.$setPristine();
            $mdDialog.hide();
        });
    }
}